module.exports = __webpack_public_path__ + "static/media/green-bg.fa7229bf.png";